var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" 新竹超才：新竹物流運費包含運送1才內的包裹(1才=長*寬*高/27000)，每超過1才加收25元超才費。 "),(_vm.isPersonal)?[_c('br'),_c('br'),_vm._v(" *部分倉庫免費，則由巧巧郎吸收新竹超才費用。"),_c('br'),_vm._v(" *家具類貨物不適用免新竹超才費優惠，推薦走漳州倉海運。 ")]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }